import { GroupClassSeriesAnalyticsSources } from "@/constants/analytics/Analytics";
import { GroupClassCarouselVariantValues } from "@/constants/Schedule";
import GroupClassSeriesCarousel from "@/ui/components/explore/GroupClassSeriesCarousel";
import type { GroupClassSeriesCarouselProps } from "@/ui/components/explore/GroupClassSeriesCarousel";
import ScreenContainer from "@/ui/layout/ScreenContainer";

const StoryMeta = {
  title: "Components/Explore/Group Class Series Carousel",
  component: GroupClassSeriesCarousel,
  argTypes: {
    variant: {
      control: "select",
      options: Object.values(GroupClassCarouselVariantValues),
    },
  },
  args: {
    variant: GroupClassCarouselVariantValues.basicGroups,
  },
  render: ({ variant }: Pick<GroupClassSeriesCarouselProps, "variant">) => (
    <ScreenContainer isScrollView>
      <GroupClassSeriesCarousel
        analyticsSource={GroupClassSeriesAnalyticsSources.ExploreTabGroups}
        tabSource="explore"
        variant={variant}
      />
    </ScreenContainer>
  ),
};

export default StoryMeta;

export const Primary = {};
